import { defineModel } from "../define-model";

export type SubscriptionStatus =
	| "trialing"
	| "active"
	| "past_due"
	| "canceled"
	| "incomplete"
	| "incomplete_expired"
	| "unpaid"
	| "paused";

/** One per workspace. Read-only: written by Stripe webhooks on the server. */
export type Subscription = {
	id: string;
	workspaceId: string;
	planId: string;
	status: SubscriptionStatus;
	interval: "month" | "year";
	seats: number;
	currentPeriodStart: string | null;
	currentPeriodEnd: string | null;
	cancelAtPeriodEnd: boolean;
	canceledAt: string | null;
	trialEndsAt: string | null;
	managedByStripe: boolean;
	createdAt: string;
	updatedAt: string;
};

declare module "../types" {
	interface SyncModels {
		subscription: Subscription;
	}
}

export const model = defineModel({ name: "subscription", load: "eager" });
